import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import {
  getCompanyScorecard,
  getCompanyTrend,
  type Scorecard,
  type Trend,
} from '@/lib/api/endpoints/scorecard'

export function useScorecard(companyId: string, quarter?: string): UseQueryResult<Scorecard> {
  return useQuery({
    queryKey: ['company', companyId, 'scorecard', quarter ?? null],
    queryFn: () => getCompanyScorecard(companyId, quarter === undefined ? {} : { quarter }),
    staleTime: 30_000,
  })
}

export function useTrend(companyId: string, enabled: boolean): UseQueryResult<Trend> {
  return useQuery({
    queryKey: ['company', companyId, 'trend'],
    queryFn: () => getCompanyTrend(companyId),
    enabled,
    staleTime: 30_000,
  })
}
